/**
 * Pinterest's standard conversion events. `window.pintrk` only exists once the
 * consent-gated tag has loaded, so a declined visitor sends nothing.
 */
type PinterestEventMap = {
  addtocart: {
    value: number;
    order_quantity: number;
    currency: string;
    line_items: { product_id: string; product_quantity: number }[];
  };
  lead: { lead_type: "Newsletter" };
  pagevisit: Record<string, never>;
};

/**
 * `buildData` runs only once the tag is there, and inside the try, so a
 * payload that can't be built never reaches the caller (a cart add, a signup).
 */
export const trackPinterest = <Name extends keyof PinterestEventMap>(
  name: Name,
  buildData: () => PinterestEventMap[Name] | null,
): void => {
  if (typeof window === "undefined" || typeof window.pintrk !== "function") {
    return;
  }
  try {
    const data = buildData();
    if (data === null) return;
    window.pintrk("track", name, data);
  } catch (error) {
    console.error(`Failed to send Pinterest ${name}:`, error);
  }
};
